import React from 'react';
import ClassAssembly  from 'views/ClassAssembly7C';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;